import { detectAdBlock } from "~/lib/ad-block";
import { gtag } from "~/lib/gtag";
export function computeGACampaignKey(name, variant) {
  const skippedVariant = new Set(["0", "1"]);
  return skippedVariant.has(variant) ? name : `${name}-${variant}`;
}
let getGaClientIdFromGTMPromise;
export async function getGAClientIdFromGTM(profileId) {
  if (getGaClientIdFromGTMPromise !== undefined) return getGaClientIdFromGTMPromise;
  const hasAdBlock = await detectAdBlock();
  getGaClientIdFromGTMPromise = hasAdBlock ? Promise.resolve(undefined) : new Promise(resolve => {
    setTimeout(() => {
      resolve(undefined);
    }, 5000);
    gtag("get", profileId, "client_id", clientId => resolve(clientId));
  });
  return getGaClientIdFromGTMPromise;
}
export async function sendGAEvent(payload) {
  try {
    const requestPayload = {
      cid: payload.clientId,
      ea: payload.event.action,
      ec: payload.event.category,
      el: payload.event.label,
      t: "event",
      tid: payload.trackingId,
      v: 1
    };
    if (location.hostname) requestPayload.dh = location.hostname;
    if (location.origin) requestPayload.dl = location.origin;
    const body = Object.entries(requestPayload).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join("&");
    const response = await fetch("https://www.google-analytics.com/collect", {
      body,
      method: "POST"
    });
    if (!response.ok) {
      const responseText = await response.text();
      throw new Error(`Bad response from Google Analytics: ${response.status}\n${responseText}`);
    }
  } catch (error) {
    console.error(new Error("Failed to send GA event", {
      cause: error
    }));
  }
}

// include the necessary fields for now
// find more details about GA4 event payload on mp docs

export async function sendGA4Event(payload) {
  var _event$category, _event$subcategory, _event$action;
  const {
    event
  } = payload;
  // mp bypass gtm so need to manually combine the event name
  const combinedEventName = `${(_event$category = event.category) !== null && _event$category !== void 0 ? _event$category : ""}_${(_event$subcategory = event.subcategory) !== null && _event$subcategory !== void 0 ? _event$subcategory : ""}_${(_event$action = event.action) !== null && _event$action !== void 0 ? _event$action : ""}`;
  try {
    const requestPayload = {
      client_id: payload.clientId,
      events: [{
        name: combinedEventName,
        params: {
          ...payload.event.customized_parameters,
          ...(location.hostname && {
            hostname: location.hostname
          }),
          ...(location.origin && {
            page_location: location.origin
          })
        }
      }]
    };
    const body = JSON.stringify(requestPayload);
    const url = new URL("https://www.google-analytics.com/mp/collect");
    url.search = new URLSearchParams({
      api_secret: payload.measurementApiKey,
      measurement_id: payload.measurementId
    }).toString();
    const response = await fetch(url, {
      body,
      method: "POST"
    });
    if (!response.ok) {
      const responseText = await response.text();
      throw new Error(`Bad response from Google Analytics: ${response.status}\n${responseText}`);
    }
  } catch (error) {
    console.error(new Error("Failed to send GA4 event", {
      cause: error
    }));
  }
}